export default function StatCards({ stats }) {
  const cards = [
    { label: "Total Submissions", value: stats?.total ?? "—" },
    { label: "New / Unread", value: stats?.new ?? "—" },
    { label: "Financial Support", value: stats?.by_type?.support ?? "—" },
    { label: "Volunteers", value: stats?.by_type?.volunteer ?? "—" },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
      {cards.map((s) => (
        <div key={s.label} className="bg-brand-bg border border-brand-line rounded-2xl p-6" data-testid="admin-stat-card">
          <div className="font-serif text-4xl text-brand-green">{s.value}</div>
          <div className="text-brand-muted text-sm mt-1">{s.label}</div>
        </div>
      ))}
    </div>
  );
}
